import { Header, HeaderItem, UserMenu } from '@skf/bt-wind-rail-commonlibrary';
import { Language } from '@skf/bt-wind-rail-commonlibrary/dist/components/layout/languageSelector/LanguageSelector';
import { PortalAccess } from '@skf/bt-wind-rail-commonlibrary/dist/components/layout/userMenu/UserMenu.types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SkfLogo from '../../../assets/skf-logo-white.svg';
import { usePathname } from '../../../hooks/usePathname';
import {
  IRoute,
  Routes,
  SettingsRoute,
  UserManagementRoute,
} from '../../../routes/routes';
import { UserAuth } from '../../../services/authentication/UserAuthentication';
import { isUserAuthorized } from '../../../services/authentication/authenticationService';
import { updateMomentLanguage } from '../../../services/languageService';
import {
  LocationConstants,
  navigateToPortalUrl,
  redirectToUrl,
} from '../../../services/location/locationService';
import { getSettings } from '../../../services/settingsService';
import { UserGroups } from '../../../store/authentication/types';
import { StoreState } from '../../../store/store';
import { IUserSettingsState } from '../../../store/userSettings/store';
import { IUsersState } from '../../../store/users/store';

interface IHeaderLayoutProps {
  signOut: () => void;
  userEmail?: string;
  pathname: string;
}

export const HeaderLayout: React.FunctionComponent<IHeaderLayoutProps> = ({
  signOut,
  userEmail,
  pathname,
}) => {
  const { i18n, t } = useTranslation();
  const { setPathname } = usePathname();

  const userSettings: IUserSettingsState = useSelector<
    StoreState,
    IUserSettingsState
  >((state) => state.userSettings);

  const userState: IUsersState = useSelector<StoreState, IUsersState>(
    (state) => state.users
  );

  const [isLanguageSelectorOpen, setLanguageSelectorOpen] = useState<boolean>(
    false
  );
  const [isUserMenuOpen, setUserMenuOpen] = useState<boolean>(false);

  const [currentSettings, setCurrentSettings] = useState<IUserSettingsState>();

  useEffect(() => {
    if (userSettings) setCurrentSettings(userSettings);
  }, [userSettings, userSettings.isFetching]);

  useEffect(() => {
    setPathname(pathname);
  }, [pathname]);

  const onLogoClick = () => {
    setPathname(UserManagementRoute.path);
  };

  const onClickLanguage = (language: Language) => {
    i18n.changeLanguage(language.code);
    updateMomentLanguage(language.code);
    setLanguageSelectorOpen(false);
  };
  const onClickLanguageOutside = () => setLanguageSelectorOpen(false);
  const onLanguageHeaderClick = () =>
    setLanguageSelectorOpen(!isLanguageSelectorOpen);

  const onUserMenuClick = () => setUserMenuOpen(!isUserMenuOpen);
  const onUserSignOutClick = () => signOut && signOut();

  const onClickDirectory = (portal: PortalAccess) => {
    if (portal.portalUrl.startsWith('http')) {
      navigateToPortalUrl(portal.portalUrl);
    } else {
      setPathname(portal.portalUrl);
    }
  };

  const getPortalsWithoutCurrentPortal = (): PortalAccess[] => {
    if (userState.userAccess && userState.userAccess.userPortalAccess) {
      const portals = userState.userAccess.userPortalAccess;
      const filteredPortals = portals.filter(
        (x) => x.webPortalUrl.includes(window.location.host) === false
      );
      return filteredPortals.map((portal) => {
        return {
          portalUrl: portal.webPortalUrl,
          portalName: portal.webPortalName,
          image: portal.webPortalIcon,
        };
      });
    }
    return [];
  };

  const filteredRoutes = Routes.filter(
    (route) => route.headerIcon && route.title
  );

  const getHeaderItem = (route: IRoute, index) => {
    let authorized = false;
    // TODO: Descomentar. El false es un workaround para que los usuarios con el rol no vean la seccion
    // let authorized = true;
    if (currentSettings && route.authorization && route.role) {
      authorized = isUserAuthorized(currentSettings, route.role);
    }

    if (authorized) return null;
    // TODO: igual que arriba
    // if (!authorized) return null;

    return (
      <HeaderItem
        key={index}
        text={t(route.title || '')}
        isActive={
          pathname.split('/')[1].toLowerCase() ===
          route.path.split('/')[1].toLowerCase()
        }
        onClick={() => setPathname(route.path)}
      >
        {route.headerIcon}
      </HeaderItem>
    );
  };

  return (
    <>
      <Header logo={SkfLogo} title={t('Portal')} onLogoClick={onLogoClick}>
        {filteredRoutes.map((route, index) => getHeaderItem(route, index))}
        {/* <HeaderItem
          isActive={isLanguageSelectorOpen}
          right={true}
          onClick={onLanguageHeaderClick}
        >
          <IconLanguage />
        </HeaderItem> */}
        {userEmail ? (
          <HeaderItem
            right={true}
            isActive={isUserMenuOpen}
            onClick={onUserMenuClick}
          >
            <UserMenu
              userEmail={userEmail}
              userPortals={getPortalsWithoutCurrentPortal()}
              isActive={isUserMenuOpen}
              onSignOutClick={onUserSignOutClick}
              userInfoStyle={{
                position: 'absolute',
                top: '1.25em',
                right: '-0.938em',
                zIndex: 999,
              }}
              onClickDirectory={onClickDirectory}
              translate={t}
            />
          </HeaderItem>
        ) : (
          <></>
        )}
      </Header>
      {/* <LanguageSelector
        languages={getLanguageList(t)}
        isOpen={isLanguageSelectorOpen}
        onClickLanguage={onClickLanguage}
        onClickOutside={onClickLanguageOutside}
      /> */}
    </>
  );
};
